<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="md-gutter create-tag-form">
          <md-field class="create-tag-form__item">
            <label>Name</label>
            <md-input
              v-model="serviceBundleForm.name"
              autofocus
            />
          </md-field>
          <md-field class="create-tag-form__item">
            <label>Comment</label>
            <md-input
              v-model="serviceBundleForm.comment"
              autofocus
            />
          </md-field>

          <md-button
            class="md-raised md-primary"
            @click="createTag"
          >
            Create
          </md-button>
        </div>
        <md-card class="md-card-plain">
          <md-card-header data-background-color="green">
            <h4 class="title">
              Server Bundles
            </h4>
          </md-card-header>
          <md-card-content>
            <server-bundles-table :key="componentKey" />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
    import {ServerBundlesTable} from "@/components";

    export default {
        components: {
            ServerBundlesTable,
        },
        data() {
            return {
                serviceBundleForm: {
                    name: "",
                    comment: "",
                },
                componentKey : 0,
            };
        },
        methods: {
            rerenderTable() {
                this.componentKey += 1;
            },
            createTag() {
                let body = {
                    server_bundle: {
                        name: this.serviceBundleForm.name,
                        comment: this.serviceBundleForm.comment
                    }
                };

                this.$http.post("/v1/admin/node/server-bundle/create", body).then(
                    res => {
                        this.rerenderTable();
                    },
                    err => {
                        console.error(err);
                    }
                );
            }
        }
    };
</script>

<style lang="scss">
    .create-tag-form {
        display: flex;
        flex-direction: row;

        .create-tag-form__item {
            width: 300px;
            margin-right: 20px;
        }
    }
</style>
